// Description: Reading list functionality.
//
// Refactored to use ES6 syntax and functions.

/**
 * Global reading list variables.
 */
var targetSelectItem;

/**
 * Handles the row click event for the reading list.
 * @param {any} sender
 * @param {any} args
 */
const readingListRowClick = (sender, args) => {
    const targetSelectItem = args.get_gridDataItem();
    if (targetSelectItem.get_selected()) {
        setTimeout(() => {
            targetSelectItem.set_selected(false);
        });
    }
};

/**
 * Handles the row deselecting event for the reading list.
 * @param {any} sender
 * @param {any} args
 */
const readingListRowDeselecting = (sender, args) => {
    if (args.get_gridDataItem().get_itemIndexHierarchical() !== targetSelectItem.get_itemIndexHierarchical()) {
        args.set_cancel(true);
    }
};
